'use strict'

var tealium;

module.exports = {
    initEventListeners: function (tealium_) {
        if(typeof window.EDSAnalyticsEventsInitialized !== 'undefined' && window.EDSAnalyticsEventsInitialized){
            return;
        }
        window.EDSAnalyticsEventsInitialized = true;
        if(typeof BreadPayments === 'undefined'){
            return;
        }
        tealium = tealium_;
        var lastRtpsLocation = null;
        var eventLocationPlc = null;
        var rtpsApprovedEventHandled = true;
        //footer links apply now
        $('#bread-payments-footer-placement').off('click').on('click', function () {
            var event = {
                tealium_event: 'link',
                event_name: 'plcc_banner_interaction',
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Apply Now'],
                event_location_plc: ['Footer Links'],
                ads_modal_type: ['Value Proposition']
            };
            tealium.triggerEvent(event);
        });

        $('.ftr-navigation-new li a').off('click').on('click', function () {
            var event;
            switch (this.innerText) {
                //footer links Pay my bill
                case "Pay My Bill":
                    event = {
                        tealium_event: 'link',
                        event_name: 'plcc_banner_interaction',
                        plcc_banner_type: ['Default'],
                        plcc_banner_interaction_selection: ['Pay My Bill'],
                        event_location_plc: ['Footer Links'],
                        ads_modal_type: ['']
                    };
                    break;
                //footer links Learn more
                case "Learn More":
                    event = {
                        tealium_event: 'link',
                        event_name: 'plcc_banner_interaction',
                        plcc_banner_type: ['Default'],
                        plcc_banner_interaction_selection: ['Learn More'],
                        event_location_plc: ['Footer Links'],
                        ads_modal_type: ['']
                    };
                    break;
            }
            if (event) {
                tealium.triggerEvent(event);
            }
        });

        //footer tile
        //Apply now
        $('#bread-payments-banner-placement').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Apply Now'],
                event_location_plc: ['Footer Tiles'],
                ads_modal_type: ['Value Proposition'],
            }
            tealium.triggerEvent(event);
        });
        //learn more
        $('#bread-payments-banner-placement').nextAll('a').not('.hide-when-live-ads').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Learn More'],
                event_location_plc: ['Footer Tiles'],
                ads_modal_type: [' ']
            }
            tealium.triggerEvent(event);
        });
        //accept now
        $('.footer-plcc-banner .eds-accept-now').on('click', function () {
            lastRtpsLocation = 'footer';
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Pre Approved'],
                plcc_banner_interaction_selection: ['Accept Now'],
                event_location_plc: ['Footer Tiles'],
                ads_modal_type: ['Pre Approved']
            }
            tealium.triggerEvent(event);
        });
        //Learn more - preapproved
        $('.footer-plcc-banner .eds-accept-now').nextAll('a').not('.hide-when-live-ads').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Pre Approved'],
                plcc_banner_interaction_selection: ['Learn More'],
                event_location_plc: ['Footer Tiles'],
                ads_modal_type: [' ']
            }
            tealium.triggerEvent(event);
        });

        //Top nav flyout
        //Apply now
        $('#bread-payments-header-placement').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Apply Now'],
                event_location_plc: ['Top Nav Flyout'],
                ads_modal_type: ['Value Proposition']
            }
            tealium.triggerEvent(event);
        });
        //learn more
        $('.plcc-popover .content-asset a.font-size-md').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Learn More'],
                event_location_plc: ['Top Nav Flyout'],
                ads_modal_type: [' ']
            }
            tealium.triggerEvent(event);
        });
        //pay bill
        $('.plcc-popover .content-asset .btn-primary').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Pay My Bill'],
                event_location_plc: ['Top Nav Flyout'],
                ads_modal_type: [' ']
            }
            tealium.triggerEvent(event);
        });

        //My account
        //Apply now
        $('#bread-payments-dashboard-placement').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Apply Now'],
                event_location_plc: ['My Account'],
                ads_modal_type: ['Value Proposition']
            }
            tealium.triggerEvent(event);
        });
        //learn more
        $('#bread-payments-dashboard-placement').nextAll('a').not('.hide-when-live-ads').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Learn More'],
                event_location_plc: ['My Account'],
                ads_modal_type: [' ']
            }
            tealium.triggerEvent(event);
        });
        //accept now
        $('.plcc-ov-top-content .eds-accept-now').on('click', function () {
            lastRtpsLocation = 'dashboard';
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Apply Now'],
                event_location_plc: ['My Account'],
                ads_modal_type: ['Pre Approved']
            }
            tealium.triggerEvent(event);
        });
        //Pre-approved - Learn More
        $('.plcc-ov-top-content .eds-accept-now').nextAll('a').not('.hide-when-live-ads').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Pre Approved'],
                plcc_banner_interaction_selection: ['Learn More'],
                event_location_plc: ['My Account'],
                ads_modal_type: [' ']
            }
            tealium.triggerEvent(event);
        });

        //PLCC landing page
        //apply now
        $('a#bread-payments-landing-placement').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Apply Now'],
                event_location_plc: ['PLCC Landing Page'],
                ads_modal_type: ['Value Proposition']
            }
            tealium.triggerEvent(event);
        });
        //Accept now - sign in to accept
        $('a#bread-payments-loyalty-placement').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Sign In to Accept'],
                event_location_plc: ['PLCC Landing Page'],
                ads_modal_type: ['Value Proposition'],
            }
            tealium.triggerEvent(event);
        });
        //Accept now - preapproved
        $('.pre-approved-cta .eds-accept-now').on('click', function () {
            lastRtpsLocation = 'landing';
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Sign In to Accept'],
                event_location_plc: ['PLCC Landing Page'],
                ads_modal_type: ['Pre Approved']
            }
            tealium.triggerEvent(event);
        });

        $('.plcc-top-content .eds-accept-now').on('click', function () {
            lastRtpsLocation = 'landing';
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Pre Approved'],
                plcc_banner_interaction_selection: ['Accept Now'],
                event_location_plc: ['PLCC Landing Page'],
                ads_modal_type: ['Pre Approved']
            }
            tealium.triggerEvent(event);
        });

        //In page banner - CA
        //Apply now
        $('#bread-payments-category-placement').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Apply Now'],
                event_location_plc: ['Nanobar'],
                ads_modal_type: ['Value Proposition']
            }
            tealium.triggerEvent(event);
        });
        //Learn more
        $('.header-promo-bottom a.learn-more').on('click', function () {
            if($('.header-promo-bottom .eds-accept-now').length > 0){
                var event = {
                    tealium_event: "link",
                    event_name: "plcc_banner_interaction",
                    plcc_banner_type: ['Pre Approved'],
                    plcc_banner_interaction_selection: ['Learn More'],
                    event_location_plc: ['Nanobar'],
                    ads_modal_type: [' ']
                }
            } else{
                var event = {
                    tealium_event: "link",
                    event_name: "plcc_banner_interaction",
                    plcc_banner_type: ['Default'],
                    plcc_banner_interaction_selection: ['Learn More'],
                    ads_modal_type: [' ']
                }
            }
            tealium.triggerEvent(event);
        });
        //accept now
        $('.header-promo-bottom .eds-accept-now').on('click', function () {
            lastRtpsLocation = 'category';
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Pre Approved'],
                plcc_banner_interaction_selection: ['Accept Now'],
                event_location_plc: ['Nanobar'],
                ads_modal_type: ['Pre Approved']
            }
            tealium.triggerEvent(event);
        });

        //PDP
        //Learn more
        $('#bread-payments-product-placement').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Learn More'],
                event_location_plc: ['PDP Promo'],
                ads_modal_type: ['Value Proposition']
            }
            tealium.triggerEvent(event);
        });

        //Cart banner
        //learn more
        $('#bread-payments-cart-placement').on('click', function () {
            lastRtpsLocation = 'cartBanner';
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Learn More'],
                event_location_plc: ['Cart Banner'],
                ads_modal_type: ['Value Proposition']
            }
            tealium.triggerEvent(event);
        });
        //Accept Now
        $('.plcc-cart-banner-container .eds-accept-now').on('click', function () {
            lastRtpsLocation = 'cartBanner';
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Pre Approved'],
                plcc_banner_interaction_selection: ['Accept Now'],
                event_location_plc: ['Cart Banner'],
                ads_modal_type: ['Pre Approved']
            }
            tealium.triggerEvent(event);
        });

        // cart tender
        //learn more
        $('#bread-payments-bag-placement').on('click', function () {
            var event = {
                tealium_event: "link",
                event_name: "plcc_banner_interaction",
                plcc_banner_type: ['Default'],
                plcc_banner_interaction_selection: ['Learn More'],
                event_location_plc: ['Cart Tender Promo'],
                ads_modal_type: ['Value Proposition']
            }
            tealium.triggerEvent(event);
        });

        //Checkout
        //rebuttal
        $(document).on('click', '.rebuttal-slot .eds-accept-now', function () {
            lastRtpsLocation = 'rebuttal';
            var event = {
                event_name: ["plc_offer_overlay", "plc_offer_rebuttal"]
            };
            tealium.triggerEvent(event);
        });
        //rtps
        $('.eds-rtps-data').on('click', function () {
            lastRtpsLocation = 'checkout';
            rtpsApprovedEventHandled = false;
        });

        //Enhance apply modal - Appy now 
        $(document).on('click', '.fbb-action-button', function (btn) {
            var location = $(this).data('location');
            eventLocationPlc = null;
            switch (location) {
                case 'footer':
                    eventLocationPlc = 'Footer Links';
                    break;
                case 'banner':
                    eventLocationPlc = 'Footer Tiles';
                    break;
                case 'header':
                    eventLocationPlc = 'Top Nav Flyout';
                    break;
                case 'dashboard':
                    eventLocationPlc = 'My Account';
                    break;
                case 'landing':
                    eventLocationPlc = 'PLCC Landing Page';
                    break;
                case 'loyalty':
                    eventLocationPlc = 'PLCC Landing Page';
                    break;
                case 'category':
                    eventLocationPlc = 'Nanobar';
                    break;
                case 'product':
                    eventLocationPlc = 'PDP Promo';
                    break;
                case 'cart':
                    eventLocationPlc = 'Cart Banner';
                    break;
                case 'bag':
                    eventLocationPlc = 'Cart Tender Promo';
                    break;
            }
            if (eventLocationPlc) {
                var event = {
                    tealium_event: "link",
                    event_name: "ads_modal_interaction",
                    ads_modal_type: ['Value Proposition'],
                    event_location_plc: [eventLocationPlc],
                    ads_modal_interaction_selection: ['Apply Now']
                }
                tealium.triggerEvent(event);
            }
        });
        //rtps - modal
        if (BreadPayments) {
            BreadPayments.on('CARD:OFFER_RESPONSE', function(response){
                if (lastRtpsLocation) {
                    eventLocationPlc = null;
                    switch (lastRtpsLocation) {
                        case 'checkout':
                            eventLocationPlc = 'plc_initial_overlay';
                            break;
                        case 'rebuttal':
                            eventLocationPlc = 'plc_rebuttal_overlay';
                            break;
                        case 'category':
                            eventLocationPlc = 'Nanobar';
                            break;
                        case 'dashboard':
                            eventLocationPlc = 'My Account';
                            break;
                        case 'landing':
                            eventLocationPlc = 'PLCC Landing Page';
                            break;
                        case 'footer':
                            eventLocationPlc = 'Footer Tiles';
                            break;
                        case 'cartBanner':
                            eventLocationPlc = 'Cart Banner';
                            break;
                    }
                    if (eventLocationPlc) {
                        var event = {
                            tealium_event: "link",
                            event_name: "ads_modal_interaction",
                            ads_modal_type: ['Pre Approved'],
                            event_location_plc: [eventLocationPlc],
                            ads_modal_interaction_selection: response === 'YES' ? ['Offer Accepted'] : ['Offer Rejected'],
                        }
                        tealium.triggerEvent(event);
                        if(eventLocationPlc == 'plc_initial_overlay' || eventLocationPlc == 'plc_rebuttal_overlay'){
                            var oldEvent = {
                                event_location_plc: [eventLocationPlc],
                                event_name: response === 'YES' ? 'plc_offer_accepted' : 'plc_offer_refused'
                            }
                            tealium.triggerEvent(oldEvent);
                        }
                    }
                }
            });
            BreadPayments.on('CARD:VIEW_PAGE', function (data) {
                if (data.pageName === 'prescreen/offer') {
                    if(rtpsApprovedEventHandled){
                        return;
                    }
                    rtpsApprovedEventHandled = true;
                    var event = {
                        event_name: ["plc_offer_overlay", "plc_offer_initial"]
                    }
                    tealium.triggerEvent(event);
                }
            });
            BreadPayments.on('CARD:RECEIVE_APPLICATION_RESULT', function (result) {
                var eventName = null;
                switch (result.result) {
                    case 'APPROVED':
                        eventName = 'plc_registration'
                        break;
                    case 'PENDING':
                        eventName = 'plc_review'
                        break;
                    case 'DECLINED':
                        eventName = 'plc_review'
                        break;
                    case 'ACCOUNT_EXISTS':
                        eventName = 'plc_already_card_holder'
                        break;
                    case 'ERROR':
                        eventName = 'plc_error'
                        break;
                }
                if (eventName && eventLocationPlc) {
                    var event = {
                        tealium_event: "link",
                        event_name: eventName,
                        event_location_plc: [eventLocationPlc],
                    }
                    tealium.triggerEvent(event);
                }
            });
        }
    }
}